import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { formateDateTime } from "../../../utils/commonFunctions";
import { deleteIcon, tableEditIcon } from "../../../assets/images";
import { CircularAvatar } from "../../commons";
import { OpenPoisitionListType } from "../../../redux/hrms/hrmsTypes";
type AppProps = {
  data: OpenPoisitionListType[] | [];
  tableHeader: TableHeadersType[];
  handleEditOpenPositionCategory: (data: any) => void;
  isEditOpenPositionPresent: boolean;
  isDeleteOpenPositionPresent: boolean;
  handleDelete: (id: string) => void;
};
const OpenPositionTableData = ({
  data,
  tableHeader,
  handleEditOpenPositionCategory,
  isEditOpenPositionPresent,
  isDeleteOpenPositionPresent,
  handleDelete,
}: AppProps) => {
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value === "position_name") {
                  return <td>{itemData?.position_name}</td>;
                } else if (item?.value == "status") {
                  return (
                    <td>{itemData?.status === true ? "Active" : "Inactive"}</td>
                  );
                } else if (item?.value == "department") {
                  return <td>{itemData?.department?.department_name}</td>;
                } else if (item?.value === "created_at") {
                  return (
                    <td>
                      <div
                        className="ml-2"
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        <div style={{ marginTop: "-16px" }}>
                          <CircularAvatar
                            name={itemData?.updated_by?.first_name}
                            image={
                              itemData?.updated_by?.profile_pic &&
                              itemData?.updated_by?.profile_pic?.file_url
                            }
                          />
                        </div>
                        <div>
                          <span>{itemData?.updated_by?.first_name}</span>
                          <p style={{ color: "#6e7491" }}>
                            {formateDateTime(itemData?.updated_at)}
                          </p>
                        </div>
                      </div>
                    </td>
                  );
                } else {
                  <td>{itemData[item?.value]}</td>;
                }
              })}
              <td style={{ width: "50px", textAlign: "start" }}>
                <div className="d-flex">
                  {isEditOpenPositionPresent && (
                    <span className="d-inline-block pointer">
                      <div
                        style={{
                          color: "#d43",
                          fontSize: 20,
                          width: "30px",
                        }}
                      >
                        <img
                          onClick={() =>
                            handleEditOpenPositionCategory?.(itemData)
                          }
                          src={tableEditIcon}
                          alt=""
                        />
                      </div>
                    </span>
                  )}
                  {isDeleteOpenPositionPresent && (
                    <span className="d-inline-block pointer">
                      <div
                        style={{
                          color: "#d43",
                          fontSize: 20,
                          width: "30px",
                        }}
                      >
                        <img
                          onClick={() => handleDelete?.(itemData?._id)}
                          src={deleteIcon}
                          alt="Delete"
                        />
                      </div>
                    </span>
                  )}
                </div>
              </td>
            </tr>
          );
        })}
    </>
  );
};

export default OpenPositionTableData;
